const CHAVES_ANTIGAS = ["usuarios", "clientes", "mailing", "leads", "kpi"];

const ouvintes = new Set();

export function inscreverAcesso(ouvinte) {
    ouvintes.add(ouvinte);
    return () => ouvintes.delete(ouvinte);
}

export function notificarAcesso() {
    ouvintes.forEach((ouvinte) => ouvinte());
}

export function limparAcesso() {
    CHAVES_ANTIGAS.forEach((chave) => localStorage.removeItem(chave));
    localStorage.removeItem("perfil");
    localStorage.removeItem("acoes");
    localStorage.removeItem("acoes_extras");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_email");
}

export function salvarAcesso(user) {
    limparAcesso();
    localStorage.setItem("perfil", user?.perfil || "");
    localStorage.setItem("acoes", JSON.stringify(user?.acoes || []));
    localStorage.setItem("acoes_extras", JSON.stringify(user?.acoes_extras || []));
    if (user?.id != null) localStorage.setItem("user_id", String(user.id));
    if (user?.email) localStorage.setItem("user_email", user.email);
    if (user?.name != null) localStorage.setItem("name", user.name || "");
    if (user?.id_assessor != null) {
        localStorage.setItem("id_assessor", String(user.id_assessor));
    } else {
        localStorage.removeItem("id_assessor");
    }
}

export function aplicarValidacao(data) {
    if (!data) return;
    if (data.perfil) localStorage.setItem("perfil", data.perfil);
    if (Array.isArray(data.acoes)) localStorage.setItem("acoes", JSON.stringify(data.acoes));
    if (Array.isArray(data.acoes_extras)) localStorage.setItem("acoes_extras", JSON.stringify(data.acoes_extras));
    notificarAcesso();
}

export function acoesAtuais() {
    try {
        const lista = JSON.parse(localStorage.getItem("acoes") || "[]");
        return Array.isArray(lista) ? lista : [];
    } catch (e) {
        return [];
    }
}

export function pode(acao) {
    return acoesAtuais().includes(acao);
}

export function nomePerfil(id) {
    const nomes = {
        master: "Master",
        gestor: "Gestor",
        auditor: "Auditor",
        assessor: "Assessor",
        confirmacao: "Confirmação",
    };
    return nomes[id] || id || "";
}

export function linkAbsoluto(link) {
    if (!link) return "";
    if (/^https?:\/\//i.test(link)) return link;
    const caminho = link.startsWith("/") ? link : `/${link}`;
    return `${window.location.origin}${caminho}`;
}

export function avisoEmail(status, email) {
    if (status === "enviado") {
        return {
            cor: "#2e7d32",
            texto: `Enviamos o link por e-mail para ${email}.`,
        };
    }
    if (status === "falhou") {
        return {
            cor: "#c62828",
            texto: "Não foi possível enviar o e-mail. Copie o link e envie por outro canal.",
        };
    }
    return null;
}

export function mensagemErro(erro, padrao) {
    const data = erro?.response?.data;
    if (data && typeof data === "object") {
        if (data.errors && typeof data.errors === "object") {
            const primeiro = Object.values(data.errors)[0];
            if (Array.isArray(primeiro) && primeiro[0]) return primeiro[0];
            if (typeof primeiro === "string") return primeiro;
        }
        if (typeof data.message === "string" && data.message) return data.message;
    }
    return padrao;
}

export function ehProprioAssessor(idAssessor, email) {
    const idGuardado = localStorage.getItem("id_assessor");
    if (idAssessor != null && idGuardado && String(idAssessor) === String(idGuardado)) return true;
    const emailGuardado = localStorage.getItem("user_email");
    if (email && emailGuardado && String(email).toLowerCase() === emailGuardado.toLowerCase()) return true;
    return false;
}

export function sair() {
    limparAcesso();
    localStorage.removeItem("access_token");
    localStorage.removeItem("name");
    localStorage.removeItem("id_assessor");
}
